import React from "react";
import {CompanyExpiry, CompanyExpiryRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {types} from "../../../../components/form/types";
import {Grid} from "@mui/material";

/** Una caducidad de la empresa (#14017). */
export const CompanyExpiryEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(CompanyExpiryRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getCompanyExpiry(id),
        updater: (bean) => ctrl.saveCompanyExpiry(bean),
        remover: (id) => ctrl.deleteOrDismissCompanyExpiry(id),
        factory: () => {
            return {category: "CERTIFICATE"} as CompanyExpiry;
        },
    } as UseFormProps<CompanyExpiry>);

    return (
        <>
            <FormContent form={form} title={"Caducidad"}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={8}>
                        <FormInput type={"text"} field={"name"} label={"Qué caduca"}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormSelect field={"category"} type={types.expiryCategories} label={"Tipo"}/>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <FormInput type={"date"} field={"expirationDate"} label={"Caduca el"}/>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <FormSelect field={"responsible"} type={types.people} label={"Responsable"} displayEmpty
                                    helperText={"Vacío: dirección"}/>
                    </Grid>
                </Grid>
                <FormInput type={"text"} field={"location"} label={"Dónde se renueva o dónde está"}/>
                <FormInput type={"text"} field={"notes"} label={"Notas"} rows={3}/>
            </FormContent>
        </>
    );
};
